import { CloseButton, Group, Stack } from "@mantine/core"
import { type ContextModalProps, openContextModal } from "@mantine/modals"
import { SurveyPeerDetails, type TSurveyPeerDetailsProps } from "./SurveyPeerDetails"

export function ModalPeerDetails({ id, context, session, ...props }: TSurveyPeerDetailsProps & ContextModalProps) {
  return (
    <Stack gap="sm">
      <Group wrap="nowrap">
        <CloseButton ml="auto" onClick={() => context.closeContextModal(id as any)} />
      </Group>
      <SurveyPeerDetails {...props} session={session} />
    </Stack>
  )
}

export function openModalPeerDetails(props: TSurveyPeerDetailsProps) {
  return openContextModal({
    size: "xl",
    withCloseButton: false,
    modal: "PeerSessionDetails",
    styles: {
      content: {
        backgroundColor: "var(--mantine-color-panel)",
      },
    },
    innerProps: props,
  })
}
